import { Flex } from "@evergis/ui";
import styled, { css } from "styled-components";

export const FieldsRow = styled(Flex)<{ withExtra?: boolean }>`
  flex-direction: row !important;
  flex-wrap: nowrap;
  width: 100%;

  > div:first-child {
    padding-right: 0.5rem;
    padding-left: 0;
    ${({ withExtra }) =>
      withExtra
        ? css`
            width: 50% !important;
          `
        : ""}
  }

  > div {
    padding-left: 0.5rem;
  }
`;
